import { GraphSchema } from '@ta/server';

import { Estate } from 'src/app/services/estates/dto/estate';

import { Revenue } from './revenue';
import { UserFieldVisibility } from './tenant';

export interface Owner {
  id: string;
  userId: string;
  status: string;
  createdDate: string;
  updatedDate: string;
  deleted: boolean;
  description: string;
  revenue: Revenue;
  estates: Estate[];
  fieldVisibilities?: UserFieldVisibility[];
}

export const ownerBrutProps: (keyof Owner)[] = [
  'id',
  'description',
  'fieldVisibilities',
  'revenue',
  'userId',
  'estates',
];
export const ownerProps = new GraphSchema<Owner>(ownerBrutProps);
